(() => {
  'use strict';

  const WRAPPER_SELECTOR = '#minicart-form .minicart__product__image';
  let repairTimer = null;

  function getImageUrl(img) {
    if (!img) return '';
    const direct = img.currentSrc || img.getAttribute('src');
    if (direct) return direct;

    const srcset = img.getAttribute('srcset');
    if (!srcset) return '';

    const firstCandidate = srcset.split(',')[0]?.trim();
    return firstCandidate ? firstCandidate.split(/\s+/)[0] : '';
  }

  function hardenImage(wrapper) {
    if (!(wrapper instanceof HTMLElement)) return;

    wrapper.style.setProperty('display', 'block', 'important');
    wrapper.style.setProperty('visibility', 'visible', 'important');
    wrapper.style.setProperty('opacity', '1', 'important');
    wrapper.style.setProperty('position', 'relative', 'important');
    wrapper.style.setProperty('overflow', 'hidden', 'important');
    wrapper.style.setProperty('flex', '0 0 9rem', 'important');
    wrapper.style.setProperty('width', '9rem', 'important');
    wrapper.style.setProperty('min-width', '9rem', 'important');
    wrapper.style.setProperty('height', '12rem', 'important');
    wrapper.style.setProperty('min-height', '12rem', 'important');
    wrapper.style.setProperty('background-size', 'cover', 'important');
    wrapper.style.setProperty('background-position', 'center', 'important');
    wrapper.style.setProperty('background-repeat', 'no-repeat', 'important');

    const link = wrapper.querySelector('a');
    if (link instanceof HTMLElement) {
      link.style.setProperty('display', 'block', 'important');
      link.style.setProperty('position', 'relative', 'important');
      link.style.setProperty('width', '100%', 'important');
      link.style.setProperty('height', '100%', 'important');
      link.style.setProperty('visibility', 'visible', 'important');
      link.style.setProperty('opacity', '1', 'important');
      link.style.setProperty('overflow', 'hidden', 'important');
    }

    const placeholder = wrapper.querySelector('.placeholder-image');
    const img = wrapper.querySelector('img');

    if (!(img instanceof HTMLImageElement)) return;

    img.loading = 'eager';
    img.fetchPriority = 'high';
    img.classList.remove('bls-loading-image');
    img.removeAttribute('width');
    img.removeAttribute('height');
    img.setAttribute('sizes', '90px');
    img.style.setProperty('display', 'block', 'important');
    img.style.setProperty('position', 'absolute', 'important');
    img.style.setProperty('inset', '0', 'important');
    img.style.setProperty('width', '100%', 'important');
    img.style.setProperty('height', '100%', 'important');
    img.style.setProperty('max-width', 'none', 'important');
    img.style.setProperty('object-fit', 'cover', 'important');
    img.style.setProperty('object-position', 'center', 'important');
    img.style.setProperty('visibility', 'visible', 'important');
    img.style.setProperty('opacity', '1', 'important');
    img.style.setProperty('z-index', '2', 'important');

    const url = getImageUrl(img);
    if (url) {
      wrapper.style.setProperty('background-image', `url("${url.replace(/"/g, '%22')}")`, 'important');
      if (placeholder instanceof HTMLElement) {
        placeholder.style.setProperty('display', 'none', 'important');
      }
      if (!img.getAttribute('src')) img.setAttribute('src', url);
    }

    img.addEventListener('load', () => {
      const loadedUrl = getImageUrl(img);
      if (loadedUrl) {
        wrapper.style.setProperty('background-image', `url("${loadedUrl.replace(/"/g, '%22')}")`, 'important');
      }
      img.classList.remove('bls-loading-image');
    }, { once: true });
  }

  function repairAll() {
    document.querySelectorAll(WRAPPER_SELECTOR).forEach(hardenImage);
  }

  function scheduleRepair() {
    clearTimeout(repairTimer);
    repairTimer = setTimeout(repairAll, 0);
    [40, 100, 200, 400, 800, 1400].forEach((delay) => setTimeout(repairAll, delay));
  }

  function init() {
    scheduleRepair();

    const cartRoot = document.getElementById('minicart_wrapper') || document.body;
    const observer = new MutationObserver(() => scheduleRepair());
    observer.observe(cartRoot, { childList: true, subtree: true });

    document.addEventListener('click', (event) => {
      if (event.target.closest('.minicart__action, .header__minicart, mini-cart-remove-button, minicart-item-edit, quantity-input')) {
        scheduleRepair();
      }
    }, true);

    document.addEventListener('transitionend', (event) => {
      if (event.target.closest?.('#minicart_wrapper, .minicart__wrapper')) {
        scheduleRepair();
      }
    }, true);

    window.addEventListener('pageshow', scheduleRepair);
    window.addEventListener('glozinspeed-allScriptsLoaded', scheduleRepair);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
